import Layout from '@gakki/components/Layout';
import React, {
  useEffect,
  useState,
} from 'react';
import {StepStatus, useAppContext} from '@gakki/context/app-context';
import {useAuthContext, useClient} from '@gakki/context/auth-context';
import {useMutation} from 'react-query';
import {
  FailDialog,
} from '@gakki/components/Dialog';
import usePageData from '@common/hooks/usePageData';
import JobTitleForm from './components/job-title-form';
import JobGradeForm, { JobGrade } from './components/job-grade-form';

export type JobTitleData = {
  jobTitles: string[],
  jobGrades: JobGrade[],
}
export default function StepJobTitle() {
  const api = useClient();
  const {companyId} = useAuthContext();
  const {changeStep, step, setIsLoading, isLoading, save, confirm, saveAndGoStep, saveFail, refetchEnablePY} = useAppContext();
  const [isFormExpand, setIsFormExpand] = useState(false);

  const {data, setData, status, remove, updatedTime} = usePageData<JobTitleData>('job-title', {
    jobTitles: [],
    jobGrades: [],
  });
  const [showFailDialog, setShowFailDialog] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    if (data !== null && status !== StepStatus.init) {
      if (data instanceof Array) { // 相容舊結構，之後可移除
        setData({
          jobTitles: data,
          jobGrades: [],
        }, StepStatus.init)
      }
      setIsLoading(false);
      return;
    }
    api
      .get(`jobtitle/company/${companyId}`)
      .then(d => setData(d, StepStatus.init))
      .finally(() => setIsLoading(false));
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function saveData(confirmData: JobTitleData) {
    return api.put(`jobtitle/company/${companyId}`, {
      data: confirmData,
    });
  }

  const {mutate: handleSave} = useMutation(saveData, {
    onSuccess: () => save(),
    onError: () => saveFail(),
    onMutate: () => setIsLoading(true),
    onSettled: () => setIsLoading(false),
  });

  function confirmData() {
    return api.put(`jobtitle/company/${companyId}/confirm`);
  }

  const {mutate: handleConfirm} = useMutation(
    () => saveData(isFormExpand ? data : { jobTitles: data?.jobTitles, jobGrades: [] })
    .then(() => refetchEnablePY('next', step + 1))
    .then(confirmData),
    {
      onSuccess: () => {
        confirm();
        changeStep(step + 1);
        remove();
      },
      onError: (error: any) => {
        if (error?.message === 'NotEnablePY') {
          return;
        }
        setShowFailDialog(true)
      },
      onMutate: () => setIsLoading(true),
      onSettled: () => setIsLoading(false),
    },
  );

  useEffect(() => {
    if (typeof saveAndGoStep === 'number') {
      handleSave(data)
    }
  }, [saveAndGoStep])

  return (
    <React.Fragment>
      <div className="flex gap-5 justify-center">
        <JobTitleForm
          jobTitles={data?.jobTitles || []}
          setJobTitles={(newJobTitles) => {
            setData({
              jobTitles: newJobTitles,
              jobGrades: data.jobGrades,
            }, StepStatus.edit);
          }}
        />
        <JobGradeForm
          isLoading={isLoading}
          isFormExpand={isFormExpand}
          setIsFormExpand={setIsFormExpand}
          jobGrades={data?.jobGrades || []}
          setJobGrades={(newJobGrades) => {
            setData({
              jobTitles: data?.jobTitles,
              jobGrades: newJobGrades,
            }, StepStatus.edit)
          }}
        />
      </div>
      <Layout.Footer
        showNextButton
        showSaveButton
        onNext={handleConfirm}
        onSave={() => handleSave(data)}
        updatedTime={updatedTime}
        disabledSaveButton={status !== StepStatus.edit || isLoading}
        disabledPrevButton={status === StepStatus.edit || isLoading}
        disabledNextButton={data?.jobTitles.length === 0 || isLoading}
      />
      <FailDialog
        isOpen={showFailDialog}
        onConfirm={() => setShowFailDialog(false)}
        onCancel={() => setShowFailDialog(false)}
      />
    </React.Fragment>
  );
}
